import React, { useState } from 'react';
import moment from 'moment';

import { env } from '~/commons/config';
import { startCase } from 'lodash';
import ListResource from './ListResource.jsx';
import ListCtrlActivates from './ListCtrlActivates.jsx';

const api = '/api/site/shares';

const ListShares = () => {
  const filter = {};
  const [status, setStatus] = useState('');

  const aCond = [];

  if (status) {
    aCond.push({ status });
  }
  if (aCond.length > 0) {
    filter.$and = aCond;
  }

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        actions: {
          create: false,
        },
        sort: { createdAt: -1 },
        filter,
        cols: [
          {
            key: 'createdAt',
            sortable: true,
            childres: 'Created At',
            getter(v) {
              return v ? moment(v).format('YYYY/MM/DD hh:mm:ss') : '';
            },
          },
          { key: 'status', sortable: true, childres: 'Status' },
          {
            key: 'address',
            sortable: true,
            children: 'Address',
            getter: (v = '') => `${v.slice(0, 6)}..${v.slice(-6)}`,
          },

          {
            key: 'creator',
            sortable: true,
            childres: 'Seller',
            getter: (v = '') => `${v.slice(0, 6)}..${v.slice(-6)}`,
          },
          { key: 'profitShare', sortable: true, childres: 'Profit Share' },
        ],
        ctrls: [
          <select
            className="custom-select"
            key={0}
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="">All</option>
            {(env?.status?.share || []).map((a) => (
              <option key={a} value={a}>
                {startCase(a)}
              </option>
            ))}
          </select>,
        ],
      }}
    >
      {({ selected, refresh }) => (
        <ListCtrlActivates api={api} selected={selected} onSuccess={refresh} />
      )}
    </ListResource>
  );
};

export default ListShares;
